import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useScratchPayEligibility } from "../../../../services/scratchpay/scratchpay.service";
import { toastMessageActions } from "../../../../state/request";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { MESSAGES } from "../constants";

export const useWellnessEligibility = () => {
  const dispatch = useDispatch();
  const {
    checkEligibility,
    eligible,
    loading: eligibilityLoading,
    error: eligibilityError,
    refetch: refetchEligibility,
  } = useScratchPayEligibility();

  useEffect(() => {
    checkEligibility({
      onCompleted: (response) => {
        const { eligible } = response.scratchpayEligibility;
        if (eligible) {
          userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_ELIGIBLE, {});
        } else {
          userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_NOT_ELIGIBLE, {});
        }
      },
      onError: (error) => {
        userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_ELIGIBILITY_ERROR, {
          error_message: error.message,
        });
        dispatch(
          toastMessageActions.setGlobalAlert({
            severity: "error",
            message: MESSAGES.ELIGIBILITY_ERROR,
          }),
        );
      },
    });
  }, []);

  return {
    eligible,
    eligibilityLoading,
    eligibilityError,
    refetchEligibility,
  };
};

